export const MoneyLessBRL = (text: string) => {

    if (text === null || text === undefined) {
        return 'R$ 0.00';
    }

    text = text.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    const money = text.trim()
        .replace(/^\D+/g, '')
        .replace(/\./g, '*')
        .replace(/\,/g, '.')
        .replace(/\*/g, ',')
        .split(',');

    return 'R$ ' + money[0];
}

export const MoneyFullBRL = (text: string) => {
    if (text === null || text === undefined) {
        return 'R$ 0.00';
    }
    const money = text.trim()
        .replace(/^\D+/g, '')
        .replace(/\./g, '*')
        .replace(/\,/g, '.')
        .replace(/\*/g, ',')
        .split(',');

    return 'R$ ' + money[0] + ',' + (money[1] === undefined ? '00' : money[1].substring(0, 2));
}

export const MoneyBRL = (text: string) => {
    if (text === null || text === undefined) {
        return 'R$ 0.00';
    }
    const formatted = Number(text.trim()).toLocaleString('pt-BR', { minimumFractionDigits:2 });
    const money = formatted.split(',');
    return 'R$ ' + money[0] + ',' + (money[1] === undefined ? '00' : money[1].substring(0, 2));
}

export const Percentual = (text: string) => {
    const percent = text.trim()
    .replace(/^\D+/g, '')
    .replace(/\./g, '*')
    .replace(/\,/g, '.')
    .replace(/\*/g, ',')
    .split(',');

    return percent[0] + ','  + (percent[1] === undefined ? '00%' : percent[1].substring(0, 2) + '%');
}


// WEBPACK FOOTER //
// ./src/services/MoneyService.tsx